import React, { useState, useEffect } from 'react'
import { motion } from 'framer-motion';
import { scrollToSection, fadeInUp } from '../utils/resource.utils';

const ToolBar = ({ ToolBarMenu }) => {
    const [darkMode, setDarkMode] = useState(() => {
        const savedTheme = localStorage.getItem('theme');
        return savedTheme === 'dark';
    });

    useEffect(() => {
        if (darkMode) {
            document.documentElement.classList.add('dark');
            localStorage.setItem('theme', 'dark');
        } else {
            document.documentElement.classList.remove('dark');
            localStorage.setItem('theme', 'light');
        }
    }, [darkMode]);

    return (
        <div className="flex items-center gap-2 rounded-md animate-[fadeInUp_0.8s_ease-out_0.2s_forwards">
            {ToolBarMenu.map((item, i) => (
                <motion.a
                    key={item.text}
                    variants={fadeInUp}
                    initial="hidden"
                    animate="visible"
                    custom={i}
                    className="inline-flex font-semibold tracking-wide bg-white hover:bg-slate-50 hover:ring-1 hover:ring-slate-300 dark:hover:ring-gray-500 items-center justify-center rounded-md text-sm lg:text-base focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:opacity-10 h-9 px-3 dark:bg-gray-800 dark:hover:bg-gray-900 dark:md:bg-gray-700 dark:md:hover:bg-gray-800 dark:text-white"
                    href={item.href}
                    onClick={(event) => scrollToSection(event, item.section)}
                >
                    {item.text}
                </motion.a>
            ))}

            <motion.button
                variants={fadeInUp}
                initial="hidden"
                animate="visible"
                onClick={() => setDarkMode(!darkMode)}
                className="inline-flex bg-white border border-slate-300 items-center justify-center rounded-md text-sm font-medium transition-transform focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:opacity-10 h-9 px-3 dark:bg-gray-800 dark:border-slate-500"
            >
                {darkMode ? (
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                        className="h-5 w-5 scale-100 dark:text-white hue-rotate-90 transition-colors">
                        <path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z"></path>
                    </svg>
                ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                        className="h-5 w-5 scale-100 rotate-180 transition-colors">
                        <circle cx="12" cy="12" r="4"></circle>
                        <path d="M12 2v2"></path>
                        <path d="M12 20v2"></path>
                        <path d="m4.93 4.93 1.41 1.41"></path>
                        <path d="m17.66 17.66 1.41 1.41"></path>
                        <path d="M2 12h2"></path>
                        <path d="M20 12h2"></path>
                        <path d="m6.34 17.66-1.41 1.41"></path>
                        <path d="m19.07 4.93-1.41 1.41"></path>
                    </svg>
                )}
                <span className="sr-only">Toggle theme</span>
            </motion.button>
        </div>
    )
}

export default ToolBar
